import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { AuthService } from 'src/app/providers/auth-service/auth-service';
import { InstitutionService } from '../../providers/institution-service/institution-service';
import { ProjectService } from '../../providers/project-service/project-service';

import { Location } from '@angular/common';

import { Institution } from 'src/app/models/Institution';
import { ConnectedInstitution } from 'src/app/models/ConnectedInstitution';

import { load } from "@finapi/web-form";

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-bank-accounts',
  templateUrl: './bank-accounts.page.html',
  styleUrls: ['./bank-accounts.page.scss'],
})
export class BankAccountsPage implements OnInit {

  createModalOpen: boolean = false;

  loading: boolean = true;
  project: any = null;

  connectedInstitutions: ConnectedInstitution[] = [];

  connectionStep: string = "search";
  searchLoading: boolean = false;
  institutionsSearch: Institution[] = [];
  selectedInstitution: Institution = null;
  
  overallBalance: number = 0;
  overallBalanceLoading: boolean = true;

  balancesStart: Date;
  balancesEnd: Date;

  webformId: string = "";
  embedWebForm: boolean = environment.finAPIEmbedding;
  @ViewChild('webFormContainer') webformContainer: any;


  constructor(
    private institutionService: InstitutionService,
    private activatedRoute: ActivatedRoute,
    private projectService: ProjectService,
    private authService: AuthService,
    private http: HttpClient,
    private location: Location,
    private renderer: Renderer2
    ) { }

    ngOnInit() {

      // -1 month from now for start
      this.balancesEnd = new Date();
      this.balancesStart = new Date(this.balancesEnd);
      this.balancesStart.setMonth(this.balancesStart.getMonth() - 1);
      this.balancesEnd.setMonth(this.balancesStart.getMonth() + 1);

      this.loadProject().then((project) => {
        this.updatePage();
      });
    }

    openBankConnectModal(){
      this.institutionService.openConnectBankAccountModal().then((result: any) => {
        if(result && result.state == "success") {
          this.updatePage();
        }
      });
    }

    loadProject() {
      return new Promise(async (resolve, reject) => {
        let projectId = this.activatedRoute.snapshot.paramMap.get('projectId');
        let currentUrl = "/bank-accounts";
        this.project = this.projectService.getCurrentProject();
        this.projectService.isReady().then(() => {
          this.projectService.getLastOpenedProject().then((lastOpenedProject) => {
  
            if (this.project && this.project.id == projectId) { // current Project was set
              return resolve(this.project);
            }
  
            if (projectId) {
              this.projectService.setCurrentProject(projectId).then(() => {
                this.project = this.projectService.getCurrentProject();
                this.loading = false;
                return resolve(this.project);
              });
            } else if (!projectId) {
  
              if (lastOpenedProject.id) { // get the last opened project
                this.projectService.setCurrentProject(lastOpenedProject.id).then(() => {
                  this.project = this.projectService.getCurrentProject();
                  this.location.replaceState(this.projectService.currentProject.id + currentUrl);
                  this.loading = false;
                  return resolve(this.project);
                });
  
              } else {
                // no Project Created yet
                //this.createProject();
                this.loading = false;
                return resolve(this.project);
              }
  
            }
  
          });
        });
      });
    }
  

  ionViewWillEnter() {
    if(this.project) this.updatePage();
  }

  updatePage() {
    this.loading = true;
    this.institutionService.getConnectedInstitutions(this.projectService.currentProject.id).then((result) => {
      this.connectedInstitutions = result.connections;
      this.loading = false;

      this.institutionService.getWebformTasks(this.projectService.currentProject.id).then((result) => {
        console.log(result, "webform tasks");
      });

      let allAccounts = [];
      this.connectedInstitutions.forEach((connection) => {
        allAccounts = allAccounts.concat(connection.accounts);
      });

      this.overallBalance = allAccounts.reduce((acc, account) => {
        return acc + account.balance;
      }, 0);
      this.overallBalanceLoading = false;

      /*
      this.institutionService.getBalances(this.projectService.currentProject.id,this.balancesStart, this.balancesEnd).then((result)=>{
        console.log("BALANCES", result);
      }); */


    });
  }

  openCreateModal() {
    this.createModalOpen = true;
    this.connectionStep = "search";
  }
  closeCreateModal() {
    this.createModalOpen = false;
    this.connectionStep = "search";
  }
  onModallDismiss() {
    this.createModalOpen = false;
    this.connectionStep = "search";
  }

  handleBankSearch(event) {
    let val = event.target.value;
    if(val.length > 2) {
      this.searchLoading = true;
      this.institutionService.searchInstitution(val).then((result) => {
        this.institutionsSearch = result.banks;
        this.searchLoading = false;
      }).catch((err) => {
        this.searchLoading = false;
      });
    }
  }

  async handleBankConnect(item: Institution) {
    let projectId = this.projectService.getCurrentProject().id;
    let institutionId = item.id;
    this.selectedInstitution = item;
  
    // @ts-ignore
    if(typeof item.bank != 'undefined'){
      return false;
    }

    this.connectionStep = "webform";

    let res = await this.institutionService.createImportRequest(institutionId, projectId);

    if(res.id) {
      this.webformId = res.id;
      if(this.embedWebForm){
        this.createWebForm();
      } else {

      }
    }

  }

  async backgroundUpdateAllConnections(){
   await this.institutionService.updateInstitutionConnection(null,this.projectService.currentProject.id, true);
  }

 /*
    EMBEDDED WEBFORM
  */
    createWebForm() {
      return new Promise( async (resolve, reject) => {
      let target = this.webformContainer.nativeElement;
      if (!target) return;
  
      let webformCSS = await this.http.get('/assets/webform.css', { responseType: 'text' }).toPromise();
  
        load(
          target,
          {
            token: this.webformId,
            targetUrl: environment.finapiWebformBase,
            layoutConfig: "xs",
          },
          {
            onComplete: () => {
              this.projectService.triggerAction(this.project,'import');
            },
            onFail: () => {
            },
            onAbort: () => {
              this.closeCreateModal();
            },
            onLoadError: () => {
              reject({ error: "loadError"});
            },
            onLoaded: () => {
              const style = this.renderer.createElement('style');
              style.innerText = webformCSS;
              this.renderer.appendChild(this.webformContainer.nativeElement.getElementsByTagName('finapi-webform2-webcomponent')[0].shadowRoot, style);
              resolve(true);
            }
          }
        );
  
      });
  
    }

}
